import "./InvitationLinkCopyButton.css";

export const buildInvitationUrl = ({ docID, version = "", invitationOnly = false, origin = "https://invitations.flashback.co.il" }) => {
  const baseUrl = `${origin}/invitation/${docID}`;
  const url = version ? `${baseUrl}?v=${encodeURIComponent(version)}` : baseUrl;
  return invitationOnly ? `${url}${version ? "&" : "?"}view=save-the-date` : url;
};

const InvitationLinkCopyButton = ({ addAlertText, docID, version = "", className = "", invitationOnly = false, label = "לחצו כאן להעתיק את הקישור להזמנה" }) => {
  const copyInvitationLink = async () => {
    try {
      await navigator.clipboard.writeText(buildInvitationUrl({ docID, version, invitationOnly, origin: ["localhost", "127.0.0.1"].includes(window.location.hostname) ? window.location.origin : undefined }));
      addAlertText({
        mode: "copied",
        text: (
          <>
            <span className="customAlert__title">הקישור הועתק בהצלחה</span>
            <span className="customAlert__line">אפשר להדביק ולשתף אותו בוואטסאפ או במייל.</span>
          </>
        ),
      });
    } catch (error) {
      addAlertText({ mode: "danger", text: "לא הצלחנו להעתיק את הקישור. נסו שוב." });
    }
  };

  return (
    <button
      type="button"
      onClick={copyInvitationLink}
      className={`invitation-link-copy-button ${className}`.trim()}
    >
      {label}
    </button>
  );
};

export default InvitationLinkCopyButton;
